<script lang="ts">
	import type { Device } from "luxedo-data"
	import { LuxedoRPC } from "luxedo-rpc"
	import { onDestroy, onMount } from "svelte"
	import LoadingSpinner from "../../loaders/LoadingSpinner.svelte"

	interface Props {
		device: Device
	}

	let { device }: Props = $props()

	let imgUrl: string = $state(undefined)
	let timestamp: number = $state()

	let interval
	async function beginImageCapture() {
		const data = await LuxedoRPC.api.device.dev_camera_record(device.id, 1)
		imgUrl = data.img_url
		interval = setInterval(() => {
			timestamp = new Date().getTime()
		}, 500)
	}

	async function endImageCapture() {
		await LuxedoRPC.api.device.dev_camera_record(device.id, 0)
		clearInterval(interval)
	}

	onMount(() => {
		beginImageCapture()
	})

	onDestroy(() => {
		endImageCapture()
	})
</script>

<div class="img-view">
	{#if !imgUrl}
		<LoadingSpinner loadingText="Capturing images..." />
	{:else}
		<img src="{imgUrl}&_ts={timestamp}" alt="" />
	{/if}
</div>

<style>
	.img-view {
		height: 100%;
		width: 100%;

		min-width: 8rem;
		min-height: 8rem;

		flex-grow: 1;
		overflow: hidden;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	img {
		max-height: 100%;
		max-width: 100%;
	}
</style>
